import React, { Component } from 'react';
import AuthService from '../utils/AuthService';
import Page from './Page';
import PageSection from './PageSection';
import Table from './Table';

var Auth = new AuthService();

// Auth logic with routes from this example:
// https://reacttraining.com/react-router/web/example/auth-workflow
class DashboardDealer extends Component {
	constructor(props) {
		super(props);

		this.Auth = new AuthService();
		this.actions = <a href="/sizing-form" className="pp-plus-button">Create Sizing Form</a>
		this.user = Auth.getProfile();
		this.state = {
			tableCreated: {
				tableHeading: [],
				tableBody: []
			},
			tablePublished: {
				tableHeading: [],
				tableBody: []
			},
			createdResults: <p className="pp-loading">Loading your sizing forms</p>,
			publishedResults: <p className="pp-loading">Loading your published reports</p>
		};

		this.createdLink = <a href="/sizing-form/status/created" className="pp-text-button">View All</a>
		this.publishedLink = <a href="/sizing-form/status/published" className="pp-text-button">View All</a>

		this.Auth.fetch('/prediction/sizing-form?status=created')
			.then((result) => {
				let header = ['Boat ', 'Date Created', 'Created By'],
					rows = [];
				if (result.success === true) {

					this.setState({
						createdResults: <span>You have no pending sizing forms. <br /><br /><a href="/sizing-form" className="pp-button">Create a sizing form</a></span>
					});

					for (let a = 0; a < result.data.length; a += 1) {
						let data = result.data[a],
							row = [];
						row.push(<a href={"/sizing-form/" + data.sizing_form_id}>{data.builder_name} {data.model_name} {data.boat_year}</a>);
						row.push(data.created_date);
						row.push(data.created_first_name + ' ' + data.created_last_name);
						rows.push(row);
					}

					this.setState({
						tableCreated: {
							tableHeading: header,
							tableBody: rows
						}
					});
				}
			});
			this.Auth.fetch('/prediction/sizing-form?status=published')
				.then((result) => {
					let header = ['Boat', 'Date Published', 'Published By'],
						rows = [];
					if (result.success === true) {

						this.setState({
							publishedResults: "You have no published reports."
						});

						for (let a = 0; a < result.data.length; a += 1) {
							let data = result.data[a],
								row = [];
							row.push(<a href={"/report/" + data.report_id}>{data.builder_name} {data.model_name} {data.boat_year}</a>);
							row.push(data.published_date);
							row.push(data.published_first_name + ' ' + data.published_last_name);
							rows.push(row);
						}

						this.setState({
							tablePublished: {
								tableHeading: header,
								tableBody: rows
							}
						});
					}
				});
	}

	render() {

		return (
			<Page pageTitle={this.user.pp_role_name + " Dashboard"} pageClass="pp-dashboard-page" pageActions={this.actions}>
				<div className="dashboard-content">
					<PageSection
						className="pp-status-created"
						sectionTitle="Pending Sizing Forms"
						sectionActions={this.createdLink}
					>
						<Table
							tableHeading={this.state.tableCreated.tableHeading}
							tableBody={this.state.tableCreated.tableBody}
							noResultsMessage={this.state.createdResults}
						/>
					</PageSection>

					<PageSection
						className="pp-status-published"
						sectionTitle="Published Performance Prediction Reports"
						sectionActions={this.publishedLink}
					>
						<Table
							tableHeading={this.state.tablePublished.tableHeading}
							tableBody={this.state.tablePublished.tableBody}
							noResultsMessage={this.state.publishedResults}
						/>
					</PageSection>
				</div>
			</Page>
		);
	}
}

export default DashboardDealer;



// WEBPACK FOOTER //
// ./src/components/DashboardDealer.js